import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const ScrollLineHeader = () => {
  const lineRef = useRef(null);

  useEffect(() => {
    const updateLine = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      console.log(scrollTop)
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      console.log(scrollHeight)
      const scrollPercent = (scrollTop / scrollHeight) * 100;
        console.log(scrollPercent)
      // Animate the line width based on scroll percentage
      gsap.to(lineRef.current, {
        width: `${scrollPercent}%`,
        duration: 0.2,
        ease: "power2.out",
      });
    };

    window.addEventListener("scroll", updateLine);
    return () => window.removeEventListener("scroll", updateLine);
  }, []);

  return (
    <div style={styles.header}>
      <div ref={lineRef} style={styles.line} className="border border-dashed"></div>
    </div>
  );
};

const styles = {
  header: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "4px",
    backgroundColor: "transparent",
    zIndex: 1000,
  },
  line: {
    height: "6px",
    width: "0%",
    backgroundColor: "blue",
    transition: "width 0.2s ease",
  },
};

export default ScrollLineHeader;
